import * as React from "react";
const SvgIcMenuVariant = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17 5v1.667H3V5h14ZM3 15h14v-1.667H3V15Zm0-4.167h14V9.167H3v1.666Z" /></svg>;
export default SvgIcMenuVariant;